var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneAll({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9767 4.47003L11.0367 3.53003L6.81 7.7567L7.75 8.6967L11.9767 4.47003ZM14.8033 3.53003L7.75 10.5834L4.96333 7.80336L4.02333 8.74336L7.75 12.47L15.75 4.47003L14.8033 3.53003ZM0.25 8.74336L3.97667 12.47L4.91667 11.53L1.19667 7.80336L0.25 8.74336Z",
    fill: "#7360F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneAll);
export default __webpack_public_path__ + "static/media/done_all.69fae1871da42ea1dc445522a91de31b.svg";
export { ForwardRef as ReactComponent };